import axios from "..";
import { ISDKConfigurationsMap } from "../../types";
import { SetSDKConfigurationsPayload } from "../../store";

export const saveSDKConfigurations = (payload: SetSDKConfigurationsPayload): Promise<void> =>
  axios.put(`/sdk/configurations`, payload);

export const getSDKConfigurations = (): Promise<ISDKConfigurationsMap> => axios.get("/sdk/configurations");
